import React, { useState } from 'react';
import { Chip } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';

const Chips = ({ items, onChange, defaultSelected = [] }) => {
  const [selected, setSelected] = useState(defaultSelected);

  const singleValues = items
    .filter(item => item.single)
    .map(item => item.value);

  const handleClick = (element) => {
    let newSelected = [];

    if (element.single) {
      if (selected.indexOf(element.value) !== -1) return;
      newSelected = [element.value];
    } else {
      const elementIsSelected = selected.indexOf(element.value) !== -1;
      newSelected = elementIsSelected
        ? selected.filter(i => i !== element.value)
        : [...selected.filter(i => !singleValues.includes(i)), element.value];
    }

    if (!newSelected.length && singleValues.length) {
      newSelected = [singleValues[0]];
    }

    setSelected(newSelected);
    onChange(newSelected);
  };

  const isSelected = (element) => selected.includes(element.value);

  return (
    <div>
      {items.map((item) => (
        <Chip
          key={item.value}
          label={item.label}
          variant="outlined"
          onClick={() => handleClick(item)}
          icon={isSelected(item) ? <CheckIcon /> : null}
          style={{
            margin: '0 2px',
            fontSize: '12px',
            fontWeight: 500,
            color: isSelected(item) ? '#2B583F' : '#4F4F4F',
            background: isSelected(item) ? '#E8F4EE' : '#fff',
            borderColor: isSelected(item) ? '#519A71' : '#BFBFBF',
          }}
        />
      ))}
    </div>
  );
};

export default Chips;
